const BASE = `${process.env.NEXT_PUBLIC_BASE_PATH ?? ''}/api/v1`;

async function refreshAccessToken(): Promise<string | null> {
  const refreshToken = localStorage.getItem('tt-refresh-token');
  if (!refreshToken) return null;
  try {
    const res = await fetch(`${BASE}/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
    });
    if (!res.ok) return null;
    const { accessToken } = await res.json();
    localStorage.setItem('tt-access-token', accessToken);
    return accessToken;
  } catch {
    return null;
  }
}

export async function apiRequest<T = any>(path: string, options: RequestInit = {}, retry = true): Promise<T> {
  let token = typeof window !== 'undefined' ? localStorage.getItem('tt-access-token') : null;

  const isFormData = options.body instanceof FormData;
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers ?? {}),
    },
  });

  // Auto-refresh on 401 and retry once
  if (res.status === 401 && retry && typeof window !== 'undefined') {
    token = await refreshAccessToken();
    if (token) return apiRequest<T>(path, options, false);
    // Refresh failed — clear tokens and redirect to login
    localStorage.removeItem('tt-access-token');
    localStorage.removeItem('tt-refresh-token');
    window.location.href = `${process.env.NEXT_PUBLIC_BASE_PATH ?? ''}/sign-up-login-screen`;
    throw { error: 'Session expired', code: 'UNAUTHORIZED' };
  }

  if (res.status === 204) return undefined as T;
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}
